export class PaymentLink {
  depositPercentage?: number;
  expirationDate?: Date;
}
